import { useTranslation } from 'react-i18next'
import { controls } from '@ocean/ui'
import { namespace } from 'core/userDeclaration/localization'
import { ModalConfirmationLayout, ModalConfirmationLayoutSegment } from 'layouts'

const { Button } = controls

const I18_PATH = `${namespace}:userDeclaration`

type PrivacyPolicyProps = {
  endUserDeclarationText: string
  onClose: Callback
}

const PrivacyPolicy: React.FC<PrivacyPolicyProps> = ({ endUserDeclarationText, onClose }) => {
  const { t } = useTranslation()
  return (
    <ModalConfirmationLayout>
      <ModalConfirmationLayoutSegment segmentId='content'>
        <div
          dangerouslySetInnerHTML={{ __html: endUserDeclarationText }}
          data-test='PrivacyPolicyContent'
        />
      </ModalConfirmationLayoutSegment>
      <ModalConfirmationLayoutSegment segmentId='actions'>
        <Button
          onClick={onClose}
          title={t(`${I18_PATH}.close`)}
          dataTest='UserDeclarationCloseButton'
        />
      </ModalConfirmationLayoutSegment>
    </ModalConfirmationLayout>
  )
}

export default PrivacyPolicy
